<template>
	<div class="flex-row flex-align-center">
		<i class="mr-4" :class="statusIcon"></i>
		<span class="fz-12">{{ statusDesc }}</span>
	</div>
</template>

<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
	computed: {
		statusDesc() {
			const textObj = {
				0: '待处理',
				1: '交接成功',
				2: '交接失败',
			};
			return textObj[this.row.status];
		},
		statusIcon() {
			const textObj = {
				0: 'check-wait',
				1: 'check-double-fill',
				2: 'check-fail',
			};
			return textObj[this.row.status];
		},
	},
};
</script>

<style>
</style>